import React, { useEffect, useState } from 'react';
import { X, Package, Truck, FileText, Calendar, Edit3 } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import EstadoBadge from './EstadoBadge';

const PAIS_LABEL = { usa: 'Estados Unidos', china: 'China' };

function Campo({ label, valor }) {
  if (valor === null || valor === undefined || valor === '') return null;
  return (
    <div>
      <label>{label}</label>
      <p style={{ color: 'var(--color-text-primary)', marginBottom: 0 }}>{valor}</p>
    </div>
  );
}

export default function PaqueteDetalleModal({ paquete, onClose, onEditar }) {
  const [historial, setHistorial] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let activo = true;
    api.get('/historial/', { params: { paquete: paquete.id } })
      .then((res) => { if (activo) setHistorial(res.data.results || res.data); })
      .catch(() => toast.error('No se pudo cargar el historial de este paquete.'))
      .finally(() => { if (activo) setCargando(false); });
    return () => { activo = false; };
  }, [paquete.id]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '640px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <Package size={18} /> {paquete.tracking || `Paquete #${paquete.id}`}
            </h3>
            <EstadoBadge estado={paquete.estado_actual_detalle} />
          </div>
          <div style={{ display: 'flex', gap: 'var(--spacing-2)' }}>
            {onEditar && (
              <button className="btn-ghost" onClick={() => { onClose(); onEditar(paquete); }} title="Editar paquete">
                <Edit3 size={18} />
              </button>
            )}
            <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
          </div>
        </div>

        <div className="form-row" style={{ marginTop: 'var(--spacing-6)' }}>
          <Campo label="Casillero" valor={paquete.cliente_detalle?.codigo_casillero} />
          <Campo label="Cliente" valor={paquete.cliente_detalle?.nombre} />
        </div>
        <div className="form-row">
          <Campo label="Tracking" valor={paquete.tracking} />
          <Campo label="Guía interna" valor={paquete.guia || 'Aún sin asignar'} />
          <Campo label="Transportista" valor={paquete.transportista?.toUpperCase()} />
        </div>
        <div className="form-row">
          <Campo label="País de origen" valor={PAIS_LABEL[paquete.pais_origen] || paquete.pais_origen} />
          <Campo label="Tienda" valor={paquete.tienda} />
          <Campo label="Orden / Factura" valor={paquete.orden_o_factura} />
        </div>
        <div className="form-row">
          <Campo label="Descripción" valor={paquete.descripcion} />
          <Campo label="Valor declarado" valor={paquete.valor_declarado ? `$${paquete.valor_declarado} ${paquete.moneda}` : null} />
        </div>
        <div className="form-row">
          <Campo label="Piezas" valor={paquete.num_piezas} />
          <Campo label="Peso" valor={paquete.peso_real ? `${paquete.peso_real} lb` : 'Pendiente de pesar'} />
          <Campo label="Dimensiones" valor={
            paquete.largo && paquete.ancho && paquete.alto
              ? `${paquete.largo} × ${paquete.ancho} × ${paquete.alto} cm`
              : null
          } />
        </div>
        <div className="form-row">
          <Campo label="¿Desea consolidar?" valor={paquete.desea_consolidar === 'si' ? 'Sí - Esperar otros paquetes' : paquete.desea_consolidar === 'no' ? 'No - Enviar en cuanto llegue' : null} />
          <Campo label="Instrucciones especiales" valor={paquete.instrucciones_especiales} />
        </div>

        {paquete.factura_adjunta && (
          <>
            <hr style={{ border: 0, borderTop: '1px solid var(--color-border)', margin: 'var(--spacing-6) 0' }} />
            <a href={paquete.factura_adjunta} target="_blank" rel="noreferrer" className="btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              <FileText size={14} /> Ver factura adjunta
            </a>
          </>
        )}

        <hr style={{ border: 0, borderTop: '1px solid var(--color-border)', margin: 'var(--spacing-6) 0' }} />

        <h4 style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><Truck size={16} /> Seguimiento</h4>
        {cargando ? (
          <p className="text-secondary text-sm">Cargando historial…</p>
        ) : historial.length === 0 ? (
          <p className="text-secondary text-sm">Todavía no hay movimientos registrados.</p>
        ) : (
          <div className="timeline" style={{ marginTop: 'var(--spacing-4)' }}>
            {historial.map((h) => (
              <div className="timeline-item" key={h.id}>
                <div className="timeline-item__fecha">
                  <Calendar size={12} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                  {new Date(h.fecha_hora).toLocaleString('es-EC')}
                </div>
                <div className="timeline-item__texto">
                  {h.estado_nuevo_nombre && (
                    <strong style={{ marginRight: '6px' }}>{h.estado_nuevo_nombre}</strong>
                  )}
                  {h.comentario_visible_cliente || (!h.estado_nuevo_nombre ? 'Cambio de estado.' : '')}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
